// extracted by mini-css-extract-plugin
export default {"newStoreButton":"items_newStoreButton__AW0n7","homepage":"items_homepage__eKCsR","icon":"items_icon__yfu3V","styledSubNavButton":"items_styledSubNavButton__DkeUy"};